import localeData, { getCountryByShortKey, getStateByKey, } from '@wix/locale-dataset-javascript';
import { getFormattedAddress } from '@wix/locale-dataset-javascript/dist/src/address-format';
export var formatCountryCode = function (_a) {
    var countryCode = _a.countryCode;
    var selectedCountry = localeData
        .getAllCountries()
        .find(function (aCountry) { return aCountry.key === countryCode; });
    if (selectedCountry) {
        return selectedCountry.shortKey;
    }
    return countryCode;
};
export var addressFormatterSingleLine = function (_a) {
    var _b = _a.street, street = _b === void 0 ? '' : _b, city = _a.city, state = _a.state, zip = _a.zip, country = _a.country, t = _a.t, _c = _a.streetNumber, streetNumber = _c === void 0 ? '' : _c, _d = _a.streetName, streetName = _d === void 0 ? '' : _d;
    return addressFormatter({
        street: street,
        city: city,
        state: state,
        zip: zip,
        country: country,
        t: t,
        streetNumber: streetNumber,
        streetName: streetName,
    })
        .replace(/\n/g, ', ')
        .replace(/ , /g, ', ');
};
export var addressFormatter = function (_a) {
    var _b = _a.street, street = _b === void 0 ? '' : _b, city = _a.city, state = _a.state, zip = _a.zip, country = _a.country, t = _a.t, _c = _a.streetNumber, streetNumber = _c === void 0 ? '' : _c, _d = _a.streetName, streetName = _d === void 0 ? '' : _d, addressLine2 = _a.addressLine2, newSubdivisionFormatEnabled = _a.newSubdivisionFormatEnabled;
    var countryObj = getCountryByShortKey(country);
    var stateObj = getStateByKey(countryObj && countryObj.key, state);
    var countryName = (countryObj === null || countryObj === void 0 ? void 0 : countryObj.key) || country;
    var stateName = (stateObj === null || stateObj === void 0 ? void 0 : stateObj.key) || state;
    var subdivisionParts = state ? state.split('-') : [];
    if (newSubdivisionFormatEnabled && subdivisionParts.length > 0) {
        stateName =
            subdivisionParts.length > 1 ? subdivisionParts[1] : subdivisionParts[0];
    }
    return getFormattedAddress({
        addressLine1: fixStreet({
            street: street,
            streetName: streetName,
            streetNumber: streetNumber,
            countryName: countryName,
        }),
        addressLine2: addressLine2,
        city: city,
        zipCode: zip,
        subdivision: state &&
            t([
                "locale-data:locale-dataset.states." + countryName + "." + stateName,
                stateName,
            ]),
        country: country &&
            t(["locale-data:locale-dataset.countries." + countryName, countryName]),
    }, countryName).trim();
};
var fixStreet = function (_a) {
    var countryName = _a.countryName, streetName = _a.streetName, streetNumber = _a.streetNumber, street = _a.street;
    if (streetName || streetNumber) {
        return [
            'IRL',
            'NLD',
            'ITA',
            'JPN',
            'NOR',
            'POL',
            'BRA',
            'PRT',
            'RUS',
            'AUT',
            'DEU',
            'CHE',
        ].indexOf(countryName) > -1
            ? (streetName + " " + streetNumber).trim()
            : (streetNumber + " " + streetName).trim();
    }
    return street;
};
//# sourceMappingURL=address.js.map